module.exports = __webpack_public_path__ + "img/btn_Live_G.303e2591.png";